/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WithSerialNumber = {
    WithSerialNumber: 'WithSerialNumber',
    WithoutSerialNumber: 'WithoutSerialNumber',
    Optional: 'Optional'
} as const;
export type WithSerialNumber = typeof WithSerialNumber[keyof typeof WithSerialNumber];


export function WithSerialNumberFromJSON(json: any): WithSerialNumber {
    return WithSerialNumberFromJSONTyped(json, false);
}

export function WithSerialNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): WithSerialNumber {
    return json as WithSerialNumber;
}

export function WithSerialNumberToJSON(value?: WithSerialNumber | null): any {
    return value as any;
}

/**
 * Check if a given object implements the WithSerialNumber interface.
 */
 export function instanceOfWithSerialNumber(value: any): value is WithSerialNumber {
    return Object.values(WithSerialNumber).includes(value)
}

